import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-auto bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
                <i className="ri-play-fill"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">糖豆视频</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300">
              汇聚优质短视频内容，涵盖娱乐、生活、趣味等多种类别，让你轻松浏览、随心分享每一个精彩瞬间。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50">热门分类</h4>
            <ul className="mt-4 space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-300 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors">
                  搜索视频
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-2 text-sm text-secondary-300">
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-primary-400">
                  <i className="ri-mail-line"></i>
                </span>
                hello@tangdouvideo.com
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-primary-400">
                  <i className="ri-phone-line"></i>
                </span>
                400-800-2026
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="https://weibo.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="微博"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-background-100 hover:bg-primary-500 transition-colors"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="https://www.douyin.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="抖音"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-background-100 hover:bg-primary-500 transition-colors"
              >
                <i className="ri-tiktok-line"></i>
              </a>
              <a
                href="https://www.bilibili.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="哔哩哔哩"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-background-100 hover:bg-primary-500 transition-colors"
              >
                <i className="ri-video-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-400">
          <p>© {year} 糖豆视频 Tangdou Video. 保留所有权利。</p>
          <p>本站为演示站点，视频内容均为示意信息。</p>
        </div>
      </div>
    </footer>
  );
}